// Imports
import axios from 'axios'
// App Imports
import { API_URL } from '../../../../setup/config/env'
import { MESSAGE_SHOW } from '../../../common/api/actions'
import { DASHBOARD_COUNT_GET_CACHE } from './cache-keys'
import {
  GET_DASHBOARD_COUNT_DONE, GET_DASHBOARD_COUNT_REQUEST, GET_DASHBOARD_COUNT_RESPONSE, LOGIN_REQUEST, LOGIN_RESPONSE, LOGOUT, SET_USER
} from './types'
import { store } from "../../../../setup/store";
import { connectToWebSocket, disconnectWebSocket } from '../../../../setup/apiWebSocket'
import { fetchSettingDetail} from '../../../setting/api/actions/query';

const deviceId = navigator.userAgent
// Actions


// Get customers
export function getUserDetails({ token }) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'checkToken',
      params: { token }
    })
  }
}

export function getUserOrders(userId) {
  return dispatch => {
    return axios.post(API_URL+"/api/order/getUserorders", { userId })
  }
}

// Check for register Email id
export function checkMail({ email }) {
  return async dispatch => {
    try {
      const { data } = await axios.post(API_URL, { operation: 'checkMailId', params: { email } })

      if (data.success) {
        dispatch({
          type: MESSAGE_SHOW,
          message: `${email} is registered email id `
        })
      } else {
        dispatch({
          type: MESSAGE_SHOW,
          message: `Please enter registered email id.`
        })
      }
      return data;
    } catch (e) {
      console.error(e)
    }
  }
}

// Login a user using credentials
export function login({ email, password }, isLoading = true) {
  return async dispatch => {
    dispatch({
      type: LOGIN_REQUEST,
      isLoading
    })

    dispatch({
      type: MESSAGE_SHOW,
      message: 'Please wait..'
    })

    try {
      const { data } = await axios.post(API_URL, {
        operation: 'userLoginAdmin',
        params: { email, password }
      },{headers: {
          "Content-Type": "application/json",
          "User-agent": deviceId
        }})
      let message = ''

      if (data.success) {
        dispatch(setUser(data.data.token, data.data.user))

        setUserInCookie(data.data.token, data.data.user)
        connectToWebSocket(store);
        dispatch(fetchSettingDetail());
        message = `Login successful. Welcome back, ${data.data.user.name}.`
      } else {
        message = data.message
      }

      dispatch({
        type: MESSAGE_SHOW,
        message
      })
    } catch (error) {
      dispatch({
        type: MESSAGE_SHOW,
        message: 'Please try again.'
      })
    } finally {
      dispatch({
        type: LOGIN_RESPONSE
      })
    }
  }
}

export const googleLogin = async (accessToken, dispatch) => {
  dispatch({
    type: MESSAGE_SHOW,
    message: 'Please wait..'
  })
  try {
    const { data } = await axios.post(`${API_URL}/api/google/loginAdmin`, { accessToken }, {headers: {
          "Content-Type": "application/json",
          "User-agent": deviceId
    }});

    let message = ''

    if (data.success) {
      dispatch(setUser(data.data.token, data.data.user))

      setUserInCookie(data.data.token, data.data.user)
      connectToWebSocket(store);
      dispatch(fetchSettingDetail());
      message = `Login successful. Welcome back, ${data.data.user.name}.`
      dispatch({
        type: MESSAGE_SHOW,
        message
      });
      return {
        success: true,
        message,
        data: data.data,
      };
    } else {
      message = data.message;
      dispatch({
        type: MESSAGE_SHOW,
        message
      })
      return {
        success: false,
        message,
        data: null,
      };
    }
    
  } catch (error) {
    console.error("Google Login failed:", error);

    return {
      success: false,
      message: error.response?.data?.message || "Google login failed. Please try again.",
      data: null,
    };
  }
};

export function getTokenFromCookie() {
  return document.cookie.split('; ').reduce((total, currentCookie) => {
    const [name, value] = currentCookie.split('=');
    if (name === 'token') {
      return decodeURIComponent(value);
    }
    return total;
  }, '');
}

export function logout() {
  return async dispatch => {
    try {
      const token = getTokenFromCookie();
      await axios.post(API_URL, { operation: 'adminUserLogout'},{
        headers :{
          "cookie-token" : token
        }
      })
      disconnectWebSocket();
    unsetUserInCookie()
      dispatch({type: LOGOUT})
      document.cookie = "token=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
      dispatch({ type: MESSAGE_SHOW, message: 'You have been successfully logged out.'})
    } catch (error) {
      console.error('Logout failed:', error)
      dispatch({ type: MESSAGE_SHOW, message: 'Logout failed. Please try again.'})
    }
  }
}

// Set a user after login or using local (AsyncStorage) token
export function setUser(token, user) {
  if (token) {
    axios.defaults.headers.common['Authentication'] = `Bearer ${token}`;
    axios.defaults.headers.common['channel'] = `admin`;
  } else {
    delete axios.defaults.headers.common['Authentication'];
  }

  return {
    type: SET_USER,
    user
  }
}

// Set user token and info locally (AsyncStorage)
export function setUserInCookie(token, user) {
  // Set token
  const date = new Date();
  date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000);
  const expires = "expires=" + date.toUTCString();
  document.cookie = `token=${token};${expires};path=/`;
  window.localStorage.setItem('user', JSON.stringify(user))
}

// Unset user token and info locally (AsyncStorage)
export function unsetUserInCookie() {
  // Remove token
  document.cookie = "token=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  window.localStorage.removeItem('user')

  // Remove cached data
  for (let item of Object.keys({ ...window.localStorage })) {
    if (item.indexOf('CACHE.KEY.') !== -1) {
      window.localStorage.removeItem(item)
    }
  }
}

// Get dashboard counts
export function getDashboardCounts(isLoading = true) {
  return async dispatch => {
    // Caching
    try {
      const counts = JSON.parse(window.localStorage.getItem(DASHBOARD_COUNT_GET_CACHE))

      if (counts) {
        dispatch({
          type: GET_DASHBOARD_COUNT_RESPONSE,
          counts
        })
      } else {
        dispatch({
          type: GET_DASHBOARD_COUNT_REQUEST,
          isLoading
        })
      }
    } catch (e) {
      dispatch({
        type: GET_DASHBOARD_COUNT_REQUEST,
        isLoading
      })
    }

    try {
      const { data } = await axios.post(API_URL, {
        operation: 'userDashboardCounts'
      })

      if (!data.success) {
        dispatch({
          type: MESSAGE_SHOW,
          success: data.success,
          message: data.message
        })
      } else {
        const counts = data.data

        dispatch({
          type: GET_DASHBOARD_COUNT_RESPONSE,
          counts
        })

        window.localStorage.setItem(DASHBOARD_COUNT_GET_CACHE, JSON.stringify(counts))
      }
    } catch (error) {
      dispatch({
        type: MESSAGE_SHOW,
        success: false,
        message: error.message
      })
    } finally {
      dispatch({
        type: GET_DASHBOARD_COUNT_DONE,
        isLoading: false
      })
    }
  }
}

// Get customers
export function listCustomers({ page , filter, sortField, sortOrder, type, role }) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'userListCustomer',
      params: { page , filter, sortField, sortOrder, type, role}
    })
  }
}
export function listAllCustomers() {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'userListAllCustomer'
    })
  }
}

// Get vendors
export function listVendors({ page }) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'userListVendor',
      params: { page }
    })
  }
}

// Get vendors all
export function listVendorsAll() {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'userListVendorAll'
    })
  }
}

// Get customers
export function detail({ userId }) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'userDetail',
      params: { userId }
    })
  }
}

// Report Order Collection Statement
export function reportOrderCollection({ startDate, endDate, pincodeId, paymentType, channel }) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'userReportOrderCollection',
      params: { startDate, endDate, pincodeId, paymentType, channel }
    })
  }
}

// Report Product Stock Statement
export function productReportStockCollection({categoryId }) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'productReportStockCollection',
      params: { categoryId }
    })
  }
}

export function pieChartCalculation({ startDate, endDate, pincodeId, paymentType }) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'calculationPieChart',
      params: { startDate, endDate, pincodeId, paymentType }
    })
  }
}

export function barChartCalculation({ startDate, endDate, pincodeId, paymentType }) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'calculationbarChart',
      params: { startDate, endDate, pincodeId, paymentType }
    })
  }
}

// Report Order Collection Statement
export function reportOrderPrepaidDeliveriesToday({ pincodeId }) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'userReportOrderPrepaidDeliveriesToday',
      params: { pincodeId }
    })
  }
}

export function customerWalletReport({ startDate, endDate }) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'customerWalletReport',
      params: { startDate, endDate }
    })
  }
}

export function productPurchaseReport({ startDate, endDate }) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'productPurchaseReport',
      params: { startDate, endDate }
    })
  }
}

export function getAppointmentMetrics() {
  return dispatch => {
    return axios.get(`${API_URL}/api/calendar/dashboard-metrics`)
  }
}